<div class="modal-header">
  <h5 class="modal-title"
      id="deleteLocationModalLabel">Delete location</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">Do you really want to delete location {{ location()?.HotelCode }}?</div>
<div class="modal-footer">
  <button type="button"
          class="btn btn-secondary"
          (click)="activeModal.close('Close click')">Close</button>
  <button type="button"
          class="btn btn-primary"
          (click)="deleteLocation()">Confirm</button>
</div>